"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var query_string_1 = __importDefault(require("query-string"));
var reconnect_js_1 = require("reconnect.js");
var CheckoutSummary_1 = __importDefault(require("../CheckoutSummary"));
var AntdAddressSetForm_1 = __importDefault(require("../AntdAddressSetForm"));
var Cart = __importStar(require("../../Actions/Cart"));
var INPUT_TYPES = {
  text: 'text',
  select: 'select'
};
function GenericInput(props) {
  var label = props.label,
    name = props.name,
    type = props.type,
    rules = props.rules,
    _a = props.config,
    config = _a === void 0 ? {} : _a;
  if (type === INPUT_TYPES.text) {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Input, __assign({}, props)));
  } else {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Select, __assign({}, props, {
      options: __spreadArray([{
        label: props.placeholder,
        value: '',
        disabled: true
      }], props.options)
    })));
  }
}
var getCvsInfo = function (values) {
  return {
    MerchantTradeNo: values.MerchantTradeNo,
    CVSStoreID: values.CVSStoreID,
    CVSStoreName: values.CVSStoreName,
    CVSAddress: values.CVSAddress,
    CVSTelephone: values.CVSTelephone,
    CVSOutSide: values.CVSOutSide
  };
};
var cvsInitialData = {
  MerchantTradeNo: '',
  CVSStoreID: '',
  CVSStoreName: '',
  CVSAddress: '',
  CVSTelephone: '',
  CVSOutSide: ''
};
var formatCheckoutFormSpecToAntdOptions = function (cart, checkoutFormSpec, updateConfig) {
  var _a;
  var paymentSubTypeOpts = checkoutFormSpec.paymentSubTypes.map(function (ps) {
    return Cart.PAYMENT_SUBTYPE_DISPLAY[ps];
  });
  var logisticsTypeOpts = checkoutFormSpec.logisticsTypes.map(function (l) {
    return Cart.LOGISTICS_TYPE_DISPLAY[l];
  });
  var logisticSubTypeOptsSet = (_a = {}, _a[Cart.LOGISTICS_TYPE.cvs] = checkoutFormSpec.logisticsSubTypes[Cart.LOGISTICS_TYPE.cvs].map(function (ls) {
    return Cart.LOGISTICS_SUBTYPE_DISPLAY[ls];
  }), _a[Cart.LOGISTICS_TYPE.home] = checkoutFormSpec.logisticsSubTypes[Cart.LOGISTICS_TYPE.home].map(function (ls) {
    return Cart.LOGISTICS_SUBTYPE_DISPLAY[ls];
  }), _a);
  var logisticSubTypeOpts = updateConfig ? logisticSubTypeOptsSet[updateConfig.logistics_type] : logisticSubTypeOptsSet[cart.logistics_type];
  return {
    paymentSubTypeOpts: paymentSubTypeOpts,
    logisticsTypeOpts: logisticsTypeOpts,
    logisticSubTypeOptsSet: logisticSubTypeOptsSet,
    logisticSubTypeOpts: logisticSubTypeOpts
  };
};
function CheckoutForm(props) {
  var _this = this;
  var _a = props.disabled,
    disabled = _a === void 0 ? false : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b;
  // outlet
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  // local state
  var form = antd_1.Form.useForm()[0];
  var _c = react_1.useState(cvsInitialData),
    cvs = _c[0],
    setCvs = _c[1];
  var isCartLoaded = react_1.useRef(false);
  var _d = react_1.useState(false),
    isSameAsBuyer = _d[0],
    setIsSameAsBuyer = _d[1];
  var _e = react_1.useState([]),
    paymentSubTypeOptions = _e[0],
    setPaymentSubTypeOptions = _e[1];
  var _f = react_1.useState([]),
    logisticsTypeOptions = _f[0],
    setLogisticsTypeOptions = _f[1];
  var _g = react_1.useState([]),
    logisticsSubTypeOptions = _g[0],
    setLogisticsSubTypeOptions = _g[1];
  var _h = react_1.useState(null),
    logisticsSubTypeOptionsSet = _h[0],
    setLogisticsSubTypeOptionsSet = _h[1];
  var getCvs = react_1.useCallback(function (values) {
    if (!!window.location.search) {
      var parsed = query_string_1.default.parse(window.location.search || '');
      return getCvsInfo(parsed);
    } else if (!!(values === null || values === void 0 ? void 0 : values.CVSStoreID)) {
      return getCvsInfo(values);
    } else {
      return cvsInitialData;
    }
  }, []);
  react_1.useEffect(function () {
    var onLoaded = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var cvsInfo, _a, updateConfig, checkoutFormSpec, _b, paymentSubTypeOpts, logisticsTypeOpts, logisticSubTypeOptsSet, logisticSubTypeOpts;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (isCartLoaded.current || cart.items.length <= 0) {
                return [2 /*return*/];
              }

              isCartLoaded.current = true;
              cvsInfo = getCvs(cart.extra_data);
              form.setFieldsValue(cart);
              _a = AppActions.onCartLoaded(cart), updateConfig = _a.updateConfig, checkoutFormSpec = _a.checkoutFormSpec;
              if (!(updateConfig && !disabled)) return [3 /*break*/, 2];
              setCvs(function (prev) {
                return __assign(__assign({}, prev), getCvs(updateConfig.extra_data));
              });
              form.setFieldsValue(updateConfig);
              return [4 /*yield*/, Cart.editConfig(updateConfig)];
            case 1:
              _c.sent();
              _c.label = 2;
            case 2:
              setCvs(function (prev) {
                return __assign(__assign({}, prev), cvsInfo);
              });
              _b = formatCheckoutFormSpecToAntdOptions(cart, checkoutFormSpec, updateConfig), paymentSubTypeOpts = _b.paymentSubTypeOpts, logisticsTypeOpts = _b.logisticsTypeOpts, logisticSubTypeOptsSet = _b.logisticSubTypeOptsSet, logisticSubTypeOpts = _b.logisticSubTypeOpts;
              setPaymentSubTypeOptions(paymentSubTypeOpts);
              setLogisticsTypeOptions(logisticsTypeOpts);
              setLogisticsSubTypeOptions(logisticSubTypeOpts);
              setLogisticsSubTypeOptionsSet(logisticSubTypeOptsSet);
              return [2 /*return*/];
          }
        });
      });
    };

    onLoaded();
  }, [AppActions, cart, cvs, disabled, form, getCvs]);
  react_1.useEffect(function () {
    if (isSameAsBuyer) {
      form.setFieldsValue({
        receiver_name: form.getFieldValue('buyer_name'),
        receiver_phone: form.getFieldValue('buyer_phone'),
        receiver_email: form.getFieldValue('buyer_email'),
        receiver_tel: form.getFieldValue('buyer_tel'),
        receiver_tel_ext: form.getFieldValue('buyer_tel_ext'),
        receiver_zip: form.getFieldValue('buyer_zip'),
        receiver_city: form.getFieldValue('buyer_city'),
        receiver_district: form.getFieldValue('buyer_district'),
        receiver_address: form.getFieldValue('buyer_address')
      });
    }
  }, [cart, form, isSameAsBuyer]);
  var onCalculateFreight = react_1.useCallback(function (_a) {
    var logisticsType = _a.logisticsType,
      logisticsSubtype = _a.logisticsSubtype;
    return __awaiter(_this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3, 4, 6]);
            return [4 /*yield*/, AppActions.setLoading(true)];
          case 1:
            _b.sent();
            return [4 /*yield*/, Cart.editConfig(__assign(__assign({}, cart), {
              extra_data: __assign({}, cvsInitialData),
              logistics_cvs_store_id: '',
              logistics_type: logisticsType,
              logistics_subtype: logisticsSubtype
            }))];
          case 2:
            _b.sent();
            return [3 /*break*/, 6];
          case 3:
            e_1 = _b.sent();
            console.warn(e_1);
            return [3 /*break*/, 6];
          case 4:
            return [4 /*yield*/, AppActions.setLoading(false)];
          case 5:
            _b.sent();
            return [7 /*endfinally*/];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  }, [AppActions, cart]);
  var getInputProps = react_1.useCallback(function (field) {
    return {
      payment_subtype: {
        label: '付款方式',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '付款方式為必填值'
        }],
        disabled: disabled,
        onChange: function (value) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = value, _a));
        },
        type: INPUT_TYPES.select,
        placeholder: '請選擇付款方式',
        options: paymentSubTypeOptions
      },
      logistics_type: {
        label: '物流方式',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '物流方式為必填值'
        }],
        disabled: disabled,
        onChange: function (value) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
              switch (_f.label) {
                case 0:
                  form.setFieldsValue((_a = {}, _a[field] = value, _a.logistics_subtype = ((_c = (_b = logisticsSubTypeOptionsSet[value]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value) || '', _a));
                  return [4 /*yield*/, onCalculateFreight({
                    logisticsType: value,
                    logisticsSubtype: (_e = (_d = logisticsSubTypeOptionsSet[value]) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.value
                  })];
                case 1:
                  _f.sent();
                  setLogisticsSubTypeOptions(logisticsSubTypeOptionsSet[value]);
                  setCvs(cvsInitialData);
                  return [2 /*return*/];
              }
            });
          });
        },

        type: INPUT_TYPES.select,
        options: logisticsTypeOptions,
        placeholder: '請選擇物流方式'
      },
      logistics_subtype: {
        label: '選擇物流商',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '物流商為必填值'
        }],
        disabled: disabled,
        onChange: function (value) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  form.setFieldsValue((_a = {}, _a[field] = value, _a));
                  return [4 /*yield*/, onCalculateFreight({
                    logisticsType: form.getFieldValue('logistics_type'),
                    logisticsSubtype: value
                  })];
                case 1:
                  _b.sent();
                  setCvs(cvsInitialData);
                  return [2 /*return*/];
              }
            });
          });
        },

        type: INPUT_TYPES.select,
        options: logisticsSubTypeOptions,
        placeholder: '請選擇物流商'
      },
      buyer_name: {
        label: '姓名',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '姓名為必填值'
        }],
        disabled: disabled,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入姓名'
      },
      buyer_phone: {
        label: '行動電話',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '行動電話為必填值'
        }, {
          len: 10,
          message: '行動電話需為 10 碼'
        }],
        maxLength: 10,
        disabled: disabled,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入行動電話'
      },
      buyer_email: {
        label: '電子郵件',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: true,
          message: '電子郵件為必填值'
        }, {
          pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
          message: '需為合法電子郵件'
        }],
        disabled: disabled,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入電子郵件'
      },
      buyer_tel: {
        label: '市話',
        name: field,
        value: form.getFieldValue(field),
        rules: [],
        disabled: disabled,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入市話'
      },
      buyer_tel_ext: {
        label: '市話分機',
        name: field,
        value: form.getFieldValue(field),
        rules: [],
        disabled: disabled,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入市話分機'
      },
      receiver_name: {
        label: '姓名',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: !isSameAsBuyer,
          message: '姓名為必填值'
        }],
        disabled: disabled || isSameAsBuyer,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入姓名'
      },
      receiver_phone: {
        label: '行動電話',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: !isSameAsBuyer,
          message: '行動電話為必填值'
        }, {
          len: 10,
          message: '行動電話需為 10 碼'
        }],
        maxLength: 10,
        disabled: disabled || isSameAsBuyer,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入行動電話'
      },
      receiver_email: {
        label: '電子郵件',
        name: field,
        value: form.getFieldValue(field),
        rules: [{
          required: !isSameAsBuyer,
          message: '電子郵件為必填值'
        }, {
          pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
          message: '需為合法電子郵件'
        }],
        disabled: disabled || isSameAsBuyer,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入電子郵件'
      },
      receiver_tel: {
        label: '市話',
        name: field,
        value: form.getFieldValue(field),
        rules: [],
        disabled: disabled || isSameAsBuyer,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入市話'
      },
      receiver_tel_ext: {
        label: '市話分機',
        name: field,
        value: form.getFieldValue(field),
        rules: [],
        disabled: disabled || isSameAsBuyer,
        onChange: function (e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入市話分機'
      }
    }[field];
  }, [disabled, form, isSameAsBuyer, logisticsSubTypeOptions, logisticsSubTypeOptionsSet, logisticsTypeOptions, onCalculateFreight, paymentSubTypeOptions]);
  var onFinish = function (data) {
    return __awaiter(_this, void 0, void 0, function () {
      var withoutCvsSelect, overridePayload, payload;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 3, 4]);
            withoutCvsSelect = data.logistics_type === Cart.LOGISTICS_TYPE.cvs && !cvs.CVSStoreID;
            if (withoutCvsSelect) {
              form.scrollToField('logistics_subtype', {
                behavior: function (e) {
                  var _a = e[0],
                    el = _a.el,
                    top = _a.top;
                  el.scrollTo({
                    left: 0,
                    top: top - 100,
                    behavior: 'smooth'
                  });
                }
              });
              antd_1.message.error('請選擇寄送超商');
              return [2 /*return*/];
            }

            AppActions.setLoading(true);
            overridePayload = isSameAsBuyer ? {
              receiver_name: data.buyer_name,
              receiver_phone: data.buyer_phone,
              receiver_email: data.buyer_email,
              receiver_zip: data.buyer_zip,
              receiver_city: data.buyer_city,
              receiver_district: data.buyer_district,
              receiver_address: data.buyer_address,
              receiver_tel: data.buyer_tel,
              receiver_tel_ext: data.buyer_tel_ext
            } : {};
            payload = __assign(__assign(__assign({}, data), {
              logistics_cvs_store_id: cvs.CVSStoreID,
              extra_data: __assign({}, cvs)
            }), overridePayload);
            return [4 /*yield*/, Cart.editConfig(payload)];
          case 1:
            _a.sent();
            return [4 /*yield*/, AppActions.navigate('/checkout/review')];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var onError = function (error) {
    console.log('debug', error);
  };
  var onSelectCVS = function () {
    return __awaiter(_this, void 0, void 0, function () {
      var values, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 5,, 6]);
            //INFO : partial validate for below 3 fields
            return [4 /*yield*/, AppActions.setLoading(true)];
          case 1:
            //INFO : partial validate for below 3 fields
            _a.sent();
            return [4 /*yield*/, form.validateFields(['payment_subtype', 'logistics_type', 'logistics_subtype'])];
          case 2:
            _a.sent();
            values = form.getFieldsValue();
            return [4 /*yield*/, Cart.editConfig(__assign(__assign({}, cart), {
              extra_data: __assign({}, cvsInitialData),
              logistics_cvs_store_id: '',
              payment_subtype: values.payment_subtype,
              logistics_type: values.logistics_type,
              logistics_subtype: values.logistics_subtype
            }))];
          case 3:
            _a.sent();
            return [4 /*yield*/, Cart.onSelectCVS()];
          case 4:
            _a.sent();
            return [3 /*break*/, 6];
          case 5:
            e_2 = _a.sent();
            console.log('debug', e_2);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };

  var commonItemConfig = {
    colon: false,
    labelAlign: 'left',
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
  return react_1.default.createElement("div", {
    style: style
  }, react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u586B\u5BEB\u8868\u55AE"), react_1.default.createElement(antd_1.Form, {
    onFinish: onFinish,
    onFinishFailed: onError,
    form: form,
    scrollToFirstError: {
      behavior: function (e) {
        var _a = e[0],
          el = _a.el,
          top = _a.top;
        el.scrollTo({
          left: 0,
          top: top - 100,
          behavior: 'smooth'
        });
      }
    },
    initialValues: cart
  }, react_1.default.createElement(antd_1.Collapse, {
    defaultActiveKey: [1, 2, 3, 4, 5]
  }, react_1.default.createElement(antd_1.Collapse.Panel, {
    header: "\u7D50\u5E33\u8CC7\u8A0A",
    key: 1
  }, react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('payment_subtype'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('logistics_type'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('logistics_subtype'))), form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.cvs && react_1.default.createElement(antd_1.Card, {
    style: {
      width: '100%'
    },
    actions: [react_1.default.createElement(antd_1.Button, {
      disabled: disabled,
      onClick: onSelectCVS
    }, "\u9078\u64C7\u8D85\u5546")]
  }, !!cvs.CVSStoreID ? react_1.default.createElement(antd_1.Card.Meta, {
    avatar: react_1.default.createElement(antd_1.Avatar, {
      shape: "square",
      src: Cart.CVS_ICON[form.getFieldValue('logistics_subtype')]
    }),
    title: cvs.CVSStoreName,
    description: cvs.CVSAddress
  }) : react_1.default.createElement(antd_1.Empty, null))), react_1.default.createElement(antd_1.Collapse.Panel, {
    header: "\u8CB7\u5BB6\u806F\u7D61\u8CC7\u8A0A",
    key: 2
  }, react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('buyer_name'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('buyer_phone'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('buyer_email'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('buyer_tel'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('buyer_tel_ext')))), react_1.default.createElement(antd_1.Collapse.Panel, {
    header: "\u8CB7\u5BB6\u5730\u5740",
    key: 3
  }, react_1.default.createElement(AntdAddressSetForm_1.default, {
    itemConfig: commonItemConfig,
    isRequired: form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.home,
    isReadOnly: disabled,
    name: "buyer",
    form: form
  })), react_1.default.createElement(antd_1.Collapse.Panel, {
    header: "\u6536\u4EF6\u4EBA\u806F\u7D61\u8CC7\u8A0A",
    key: 4,
    extra: !disabled ? react_1.default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, react_1.default.createElement(antd_1.Checkbox, {
      checked: isSameAsBuyer,
      onClick: function (e) {
        e.stopPropagation();
      },
      onChange: function (e) {
        setIsSameAsBuyer(e.target.checked);
      }
    }), react_1.default.createElement("div", {
      style: {
        paddingLeft: 10
      },
      onClick: function (e) {
        e.stopPropagation();
        setIsSameAsBuyer(function (prev) {
          return !prev;
        });
      }
    }, "\u540C\u8CB7\u5BB6")) : null
  }, react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('receiver_name'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('receiver_phone'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('receiver_email'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('receiver_tel'))), react_1.default.createElement(GenericInput, __assign({
    config: commonItemConfig
  }, getInputProps('receiver_tel_ext')))), react_1.default.createElement(antd_1.Collapse.Panel, {
    header: "\u6536\u4EF6\u4EBA\u5730\u5740",
    key: 5
  }, react_1.default.createElement(AntdAddressSetForm_1.default, {
    itemConfig: commonItemConfig,
    name: "receiver",
    form: form,
    isReadOnly: disabled || isSameAsBuyer,
    isRequired: !isSameAsBuyer && form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.home
  }))), !disabled && react_1.default.createElement(CheckoutSummary_1.default, {
    cart: cart,
    onClick: form.submit,
    disabled: false
  })));
}
exports.default = CheckoutForm;